const data = {
	"width": 256,
	"height": 256,
	"body": "<path fill=\"currentColor\" d=\"m181.7 133.7l-80 80A8.3 8.3 0 0 1 96 216a8.5 8.5 0 0 1-3.1-.6A8 8 0 0 1 88 208V48a8 8 0 0 1 4.9-7.4a8.4 8.4 0 0 1 8.8 1.7l80 80a8.1 8.1 0 0 1 0 11.4Z\"/>"
};
export default data;
